import { alpha, Box, Button, Stack, TextField, Typography } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { CardHeader } from '../../../app/AppStyles';
import NotificationsTestButton from '../../notifications/NotificationsTestButton';
import { setAlertMessage, setAlertSeverity, setAlertStatus } from '../../subcomponents/alertSlice';
import { fetchMoveImagesToAzure, fetchPeriodsForBulkAdd, postBulkMoments } from '../adminSlice';
import AutocompleteSelector from '../../subcomponents/AutocompleteSelector';

export default function AdminFunctionsTab() {
    const dispatch = useDispatch();

    const [recipient, setRecipient] = useState("");
    const [message, setMessage] = useState("Test message");
    const [imageType, setImageType] = useState("");
    const [momentsAmount, setMomentsAmount] = useState(1);
    const [selectedPeriod, setSelectedPeriod] = useState(null);

    const { appLanguage, resourceFinal } = useSelector((state) => state.settings.resource.resources);
    const { moveImagesToAzure, bulkMoments, bulkPeriods } = useSelector((state) => state.admin);
    const { siomSettings } = useSelector((state) => state.settings.siom);
    const { activeDepartment } = useSelector((state) => state.settings.theme)

    useEffect(() => {
        const departmentId = siomSettings.useMultipleDepartments && activeDepartment ? activeDepartment[0]?.id : null;

        dispatch(fetchPeriodsForBulkAdd(departmentId));
    }, [activeDepartment]);

    // Azure images Callback
    useEffect(() => {
        if (moveImagesToAzure.status === "success") {
            dispatch(setAlertStatus(true));
            dispatch(setAlertMessage(`${resourceFinal[appLanguage].admin.AZURE_IMAGES_CHANGED_SUCCESS}`));
            dispatch(setAlertSeverity("success"));
        } else if (moveImagesToAzure.status === "failed") {
            dispatch(setAlertStatus(true));
            dispatch(setAlertMessage(`${resourceFinal[appLanguage].admin.AZURE_IMAGES_CHANGED_FAILED}`));
            dispatch(setAlertSeverity("error"));
        }
    }, [moveImagesToAzure.status]);

    // Bulk moments Callback
    useEffect(() => {
        if (bulkMoments.status === "success") {
            dispatch(setAlertStatus(true));
            dispatch(setAlertMessage(`${bulkMoments.data} ${resourceFinal[appLanguage].admin.BULK_MOMENTS_ADD_SUCCESS}`));
            dispatch(setAlertSeverity("success"));
        } else if (bulkMoments.status === "failed") {
            dispatch(setAlertStatus(true));
            dispatch(setAlertMessage(`${resourceFinal[appLanguage].admin.BULK_MOMENTS_ADD_FAILED}`));
            dispatch(setAlertSeverity("error"));
        }
    }, [bulkMoments.status]);

    const handleMoveImagestoAzure = (imageType) => {
        dispatch(fetchMoveImagesToAzure(imageType));
    };

    const handleBulkMomentsAdd = () => {
        dispatch(postBulkMoments({ periodId: selectedPeriod.periodId, amount: momentsAmount }));
    };

    return (
        <Box sx={{ width: 1 }}>
            <Grid container spacing={1}>
                <Grid container spacing={1} size={{ xs: 12, md: 3 }} sx={{ bgcolor: theme => `${alpha(theme.palette.primary.light, 0.3)}`, border: 1, borderColor: 'white.dark', borderRadius: 1, p: 1 }}>
                    <Stack spacing={1} sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'space-between',
                        flex: '1 1 auto',
                        border: 1,
                        borderColor: 'white.dark',
                        borderRadius: 1,
                        bgcolor: 'white.light',
                        p: 1
                    }}>
                        <Typography variant="body1" sx={{ ...CardHeader, color: 'black.light' }}>
                            {resourceFinal[appLanguage].words.TEST} {resourceFinal[appLanguage].words.NOTIFICATION} {resourceFinal[appLanguage].words.SEND2}
                        </Typography>
                        <TextField
                            fullWidth required
                            value={recipient}
                            label={resourceFinal[appLanguage].words.MESSAGE_RECEIVER}
                            onChange={(e) => setRecipient(e.target.value)}
                            variant="outlined"
                        />
                        <TextField
                            fullWidth required
                            value={message}
                            label={resourceFinal[appLanguage].words.MESSAGE}
                            onChange={(e) => setMessage(e.target.value)}
                            variant="outlined"
                        />
                        <NotificationsTestButton disabled={!recipient || !message} recipient={recipient} message={message} />
                    </Stack>
                </Grid>
                <Grid container spacing={1} size={{ xs: 12, md: 3 }} sx={{ bgcolor: theme => `${alpha(theme.palette.secondary.light, 0.3)}`, border: 1, borderColor: 'white.dark', borderRadius: 1, p: 1 }}>
                    <Stack spacing={1} sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'space-between',
                        flex: '1 1 auto',
                        border: 1,
                        borderColor: 'white.dark',
                        borderRadius: 1,
                        bgcolor: 'white.light',
                        p: 1
                    }}>
                        <Typography variant="body1" sx={{ ...CardHeader, color: 'black.light' }}>
                            {resourceFinal[appLanguage].words.AZURE_MIGRATION}
                        </Typography>
                        <TextField
                            fullWidth required
                            value={imageType}
                            label={resourceFinal[appLanguage].words.AZURE_IMAGETYPE}
                            onChange={(e) => setImageType(e.target.value)}
                            variant="outlined"
                        />
                        <Button
                            variant="outlined"
                            disabled={!imageType}
                            onClick={() => handleMoveImagestoAzure(imageType)}
                        >
                            {resourceFinal[appLanguage].words.SEND}
                        </Button>
                    </Stack>
                </Grid>
                <Grid container spacing={1} size={{ xs: 12, md: 3 }} sx={{ bgcolor: theme => `${alpha(theme.palette.primary.light, 0.3)}`, border: 1, borderColor: 'white.dark', borderRadius: 1, p: 1 }}>
                    <Stack spacing={1} sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'space-between',
                        flex: '1 1 auto',
                        border: 1,
                        borderColor: 'white.dark',
                        borderRadius: 1,
                        bgcolor: 'white.light',
                        p: 1
                    }}>
                        <Typography variant="body1" sx={{ ...CardHeader, color: 'black.light' }}>
                            {resourceFinal[appLanguage].admin.BULK_MOMENTS_ADD}
                        </Typography>
                        <AutocompleteSelector
                            label={resourceFinal[appLanguage].words.PERIOD}
                            options={bulkPeriods.data ?? []}
                            value={selectedPeriod ?? null}
                            onChange={(val) => {
                                setSelectedPeriod(val)
                            }}
                            getOptionLabel={(option) => option.name}
                            isOptionEqualToValue={(option, value) => option.periodId === value?.periodId}
                        />
                        <TextField
                            fullWidth type="number"
                            label={resourceFinal[appLanguage].words.MOMENTS}
                            value={momentsAmount}
                            inputProps={{ min: 1 }}
                            onChange={(e) => {
                                setMomentsAmount(e.target.value);
                            }}
                            variant="standard"
                        />
                        <Button
                            variant="outlined"
                            disabled={!selectedPeriod}
                            onClick={() => handleBulkMomentsAdd()}
                        >
                            {resourceFinal[appLanguage].words.ADD}
                        </Button>
                    </Stack>
                </Grid>
            </Grid>
        </Box>
    );
}
